/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onCreateTranscriberConfig = /* GraphQL */ `
  subscription OnCreateTranscriberConfig {
    onCreateTranscriberConfig {
      id
      param
      value
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateTranscriberConfig = /* GraphQL */ `
  subscription OnUpdateTranscriberConfig {
    onUpdateTranscriberConfig {
      id
      param
      value
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteTranscriberConfig = /* GraphQL */ `
  subscription OnDeleteTranscriberConfig {
    onDeleteTranscriberConfig {
      id
      param
      value
      createdAt
      updatedAt
    }
  }
`;
